import {
  GET_CHANGE_MOBILE_CARD_PROFILE_REQUEST,
  GET_CHANGE_MOBILE_CARD_PROFILE_SUCCESS,
  GET_CHANGE_MOBILE_CARD_PROFILE_FAILURE,
  GET_EXISTING_MOBILE_REQUEST,
  GET_EXISTING_MOBILE_FAILURE,
  GET_EXISTING_MOBILE_SUCCESS
} from './actionTypes';
import { IChangeMobileNoCardProfile, IExistingMobileNumber } from './models/types';

export const getChangeMobileNoCardProfile = {
  request: (reqData: IChangeMobileNoCardProfile, callback) => ({
    type: GET_CHANGE_MOBILE_CARD_PROFILE_REQUEST,
    reqData,
    callback
  }),

  success: (data) => ({
    type: GET_CHANGE_MOBILE_CARD_PROFILE_SUCCESS,
    data
  }),
  failure: (error) => ({
    type: GET_CHANGE_MOBILE_CARD_PROFILE_FAILURE,
    error
  })
};

export const getExistingMobileNumber = {
  request: (reqData: IExistingMobileNumber) => ({
    type: GET_EXISTING_MOBILE_REQUEST,
    reqData
  }),
  success: (data) => ({
    type: GET_EXISTING_MOBILE_SUCCESS,
    data
  }),
  failure: (error) => ({
    type: GET_EXISTING_MOBILE_FAILURE,
    error
  })
};
